import { Text, Button, Flex } from '@radix-ui/themes'
import { useNavigate } from 'react-router-dom'

export const HomePage = () => {
  const navigate = useNavigate()

  return (
    <Flex direction="column" gap="4" align="center">
      <Text size="5" weight="bold">
        ABLunch에 오신 것을 환영합니다
      </Text>
      <Text color="gray">
        회사 직원들이 지도를 연동하여 음식점과 음식을 기록하는 서비스
      </Text>
      <Flex gap="2">
        <Button onClick={() => navigate('/map')}>지도 보기</Button>
        <Button onClick={() => navigate('/feed')} variant="soft">
          피드 보기
        </Button>
      </Flex>
    </Flex>
  )
}